<ng-container *ngIf="pageMode">
  <div #content>
    <ng-container *ngIf="true then how"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="!pageMode">
  <ion-header>
    <ion-toolbar color="light">
      <ion-buttons slot="start">
        <ion-button (click)="dismissModal()">
          <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        <app-offline-indicator></app-offline-indicator>
        {{ 'BLAST.how.title' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-text-center" color="light" #content>
    <ng-container *ngIf="true then how"></ng-container>
  </ion-content>
  <ion-footer>
    <ion-toolbar>
      <div class="ion-margin">
        <ion-button expand="block" (click)="presentTemplateManageModal()">
          {{ 'BTN.get_start' | translate }}
        </ion-button>
      </div>
    </ion-toolbar>
  </ion-footer>
</ng-container>

<ng-template #how>
  <div>
    <ion-img class="img center" src="./assets/wedding/img/blast/how.svg"></ion-img>
  </div>
  <div class="ion-margin">
    <div>
      <ion-text class="font-20 font-med">
        {{ 'BLAST.how.why.title' | translate }}
      </ion-text>
    </div>
    <div>
      <ion-text class="font-12">
        {{ 'BLAST.how.intro' | translate }}
      </ion-text>
    </div>
    <div class="why-div center ion-text-left ion-padding-horizontal">
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/time_saving.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.time_saving' | translate }}
        </ion-text>
      </div>
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/auto.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.auto' | translate }}
        </ion-text>
      </div>
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/track.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.track' | translate }}
        </ion-text>
      </div>
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/experience.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.experience' | translate }}
        </ion-text>
      </div>
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/customize.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.customize' | translate }}
        </ion-text>
      </div>
      <div class="ion-margin">
        <ion-icon class="font-30 icon vertical-middle" src="./assets/wedding/img/blast/how/template.svg" color="success"></ion-icon>
        <ion-text class="font-12">
          {{ 'BLAST.how.why.template' | translate }}
        </ion-text>
      </div>
    </div>
  </div>

  <div class="ion-margin ion-padding">
    <div class="ion-margin">
      <div>
        <ion-text class="font-16 font-med">
          {{ 'BLAST.how.start.title' | translate }}
        </ion-text>
      </div>
  
      <div>
        <ion-text class="font-12">
          {{ 'BLAST.how.start.steps' | translate }}
        </ion-text>
      </div>
    </div>
    
    <div class="ion-padding">
      <ion-img class="img-step center" src="./assets/wedding/img/blast/step1.svg"></ion-img>
      <div class="ion-margin">
        <ion-text class="font-12 font-med">
          {{ 'BLAST.how.start.step1' | translate }}
        </ion-text>
      </div>
    </div>
    <div class="ion-padding">
      <ion-img class="img-step center" src="./assets/wedding/img/blast/step2.svg"></ion-img>
      <div class="ion-margin">
        <ion-text class="font-12 font-med">
          {{ 'BLAST.how.start.step2' | translate }}
        </ion-text>
      </div>
    </div>
    <div class="ion-padding">
      <ion-img class="img-step center" src="./assets/wedding/img/blast/step3.svg"></ion-img>
      <div class="ion-margin">
        <ion-text class="font-12 font-med">
          {{ 'BLAST.how.start.step3' | translate }}
        </ion-text>
      </div>
    </div>
  </div>
</ng-template>